import { Pipe, PipeTransform } from '@angular/core';
import { Resource } from '../models/resource.model';

/**Pipe che verifica se una risorsa è assegnata a un utente */
@Pipe({
  name: 'checkAssignedResource'
})
export class CheckAssignedResourcePipe implements PipeTransform {

  /**
   * Metodo dell'interfaccia PipeTransform che effettua il controllo
   * @param nodeId {number} identificativo del nodo da verificare
   * @param assignedResources {Resource[]} lista delle risorse assegnate all'utente loggato
   * @returns se la risorsa è assegnara
   */
  transform(nodeId: number, assignedResources: Resource[]): boolean {
    let find = assignedResources.findIndex(e => e.id === nodeId);
    return find === -1 ? false : true;
  }

}
